import { Controller } from "@hotwired/stimulus"

// Keeps the first N table columns fixed during horizontal scrolling.
// Works with TableComponent's declarative mode by marking cells with:
//   - `fanword-table__sticky-left`
// and dynamically setting `left` offsets via measured header widths.
export default class extends Controller {
  static values = { stickyLeftColumns: Number }

  connect() {
    this.resizeTimeout = null
    this.handleResize = this.handleResize.bind(this)

    this.updateStickyColumns()
    window.addEventListener("resize", this.handleResize)
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize)
    if (this.resizeTimeout) clearTimeout(this.resizeTimeout)
  }

  handleResize() {
    if (this.resizeTimeout) clearTimeout(this.resizeTimeout)

    // Debounce to avoid repeated layout thrashing while resizing.
    this.resizeTimeout = setTimeout(() => {
      this.updateStickyColumns()
    }, 50)
  }

  updateStickyColumns() {
    const stickyCount = this.stickyLeftColumnsValue || 0
    if (stickyCount <= 0) return

    const table = this.element.querySelector("table")
    if (!table) return

    const stickyHeaderCells = Array.from(
      // account for blank cells in the header that are <td> elements
      table.querySelectorAll("thead th.fanword-table__sticky-left, thead td.fanword-table__sticky-left")
    )

    if (stickyHeaderCells.length === 0) return

    const headerCells = stickyHeaderCells.slice(0, stickyCount)

    // Compute left offsets using measured header widths.
    const offsets = []
    let currentLeft = 0

    headerCells.forEach((cell, idx) => {
      offsets[idx] = currentLeft
      const width = cell.getBoundingClientRect().width
      currentLeft += width
    })

    headerCells.forEach((cell, idx) => {
      cell.style.left = `${offsets[idx]}px`
    })

    // Apply the same offsets to each body row's sticky cells.
    const bodyRows = Array.from(table.querySelectorAll("tbody tr"))
    bodyRows.forEach(row => {
      const stickyBodyCells = Array.from(
        row.querySelectorAll("td.fanword-table__sticky-left")
      )

      stickyBodyCells.slice(0, stickyCount).forEach((cell, idx) => {
        cell.style.left = `${offsets[idx]}px`
      })
    })
  }
}

